import React from 'react';
import { IOrderProductComboItem } from 'src/types/orders';

interface IProps {
  item: IOrderProductComboItem;
}

export const OrderItem: React.FC<IProps> = ({ item }) => {
  return (
    <div className="details-modifier">
      <p className="details-modifier-option">{item.name}</p>
    </div>
  );
};
